import { makeStyles } from "@material-ui/core/styles";

export const useInputStyles = makeStyles((theme) => ({
  label: {
    color: "#999999",
    display: "block",
    margin: "0 0 8px 0",
  },
  wrapper: {
    display: "block",
    margin: "0 0 20px 0",
  },
}));
